import {
  defaultFields,
  defaultHistoryFields,
} from '@trashlab/api/drizzle/default';
import { organization } from '@trashlab/api/src/domains/identity/schemas/organization';
import { identity_user } from '@trashlab/api/src/domains/identity/schemas/identity-user';
import { orders } from '@trashlab/api/src/domains/orders/schemas/orders';
import { organization_website } from '@trashlab/api/src/domains/website/schemas/organization-website';
import {
  pgEnum,
  pgTable,
  uuid,
  varchar,
  index,
  foreignKey,
  date,
  timestamp,
} from 'drizzle-orm/pg-core';
import { customer_contact } from '@trashlab/api/src/domains/customer/schemas/customer-contact';
import { organization_domain } from '@trashlab/api/src/domains/website/schemas/organization-domain';

export const service_request_status = pgEnum('service_request_status', [
  'PENDING',
  'CONTACTED',
  'COMPLETED',
  'CANCELLED',
]);

export const service_request = pgTable(
  'service_request',
  {
    ...defaultFields.fieldsWithTenantId(),
    firstName: varchar('firstName', { length: 255 }).notNull(),
    lastName: varchar('lastName', { length: 255 }).notNull(),
    email: varchar('email', { length: 255 }).notNull(),
    phone: varchar('phone', { length: 50 }).notNull(),
    serviceRequested: varchar('serviceRequested', { length: 255 }).notNull(),
    preferredServiceDate: date('preferredServiceDate'),
    status: service_request_status('status').default('PENDING').notNull(),
    readBy: uuid('readBy'),
    orderId: uuid('orderId'),
    websiteId: uuid('websiteId'),
    domainId: uuid('domainId'),
    contactId: uuid('contactId'),
  },
  (table) => ({
    createdAtTs_idx: index('service_request_createdAtTs_idx').on(
      table.createdAtTs,
    ),
    tenantId_idx: index('service_request_tenantId_idx').on(table.tenantId),
    updatedAtTs_idx: index('service_request_updatedAtTs_idx').on(
      table.updatedAtTs,
    ),
    updatedAtTs_idx1: index('service_request_updatedAtTs_idx1').on(
      table.updatedAtTs.desc(),
    ),
    versionNumber_idx: index('service_request_versionNumber_idx').on(
      table.versionNumber,
    ),
    email_idx: index('service_request_email_idx').on(table.email),
    phone_idx: index('service_request_phone_idx').on(table.phone),
    status_idx: index('service_request_status_idx').on(table.status),
    preferredServiceDate_idx: index(
      'service_request_preferredServiceDate_idx',
    ).on(table.preferredServiceDate),
    contactId_idx: index('service_request_contactId_idx').on(table.contactId),

    organizationId_fkey: foreignKey({
      columns: [table.tenantId],
      foreignColumns: [organization.id],
      name: 'service_request_organizationId_fkey',
    }),

    orderId_fkey: foreignKey({
      columns: [table.orderId],
      foreignColumns: [orders.id],
      name: 'service_request_orderId_fkey',
    }),

    readBy_fkey: foreignKey({
      columns: [table.readBy],
      foreignColumns: [identity_user.id],
      name: 'service_request_readBy_fkey',
    }),

    websiteId_fkey: foreignKey({
      columns: [table.websiteId],
      foreignColumns: [organization_website.id],
      name: 'service_request_websiteId_fkey',
    }),

    domainId_fkey: foreignKey({
      columns: [table.domainId],
      foreignColumns: [organization_domain.id],
      name: 'service_request_domainId_fkey',
    }),

    contactId_fkey: foreignKey({
      columns: [table.contactId],
      foreignColumns: [customer_contact.id],
      name: 'service_request_contactId_fkey',
    }),
  }),
);

export const service_request_history = pgTable('service_request_history', {
  ...defaultHistoryFields.historyFieldsWithTenantId(),
  firstName: varchar('firstName', { length: 255 }),
  lastName: varchar('lastName', { length: 255 }),
  email: varchar('email', { length: 255 }),
  phone: varchar('phone', { length: 50 }),
  serviceRequested: varchar('serviceRequested', { length: 255 }),
  preferredServiceDate: date('preferredServiceDate'),
  status: service_request_status('status'),
  readBy: uuid('readBy'),
  orderId: uuid('orderId'),
  websiteId: uuid('websiteId'),
  domainId: uuid('domainId'),
  contactId: uuid('contactId'),
});

export type ServiceRequestSchema = typeof service_request.$inferSelect; 